import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Highlight } from '../../../../components/Title';
import TextBlock from '../../../../components/TextBlock';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import tabletFlat from '../../../../assets/images/pages/patient-hope/tablet-landscape-flat.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.purple};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 156px 0 0;
  }
`;

const Content = ContentContainer.extend`
  position: relative;
`;

const IPadPosition = styled.div`
  max-width: 388px;

  @media ${device.mobileL} {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: -43%;
    max-width: 500px;
  }

  @media ${device.tablet} {
    right: -41%;
    max-width: 824px;
  }

  @media ${device.laptop} {
    right: -40%;
    max-width: 921px;
  }
`;

const FinalProjectScreen = () => (
  <StyledScreen>
    <Content>
      <Title primary={false} className="title" color={brandColors.white}>
        Clean <br />
        <Highlight>and</Highlight> elegant
      </Title>
      <br />
      <TextBlock width="382px" color={brandColors.white}>
        <p>
          The final outcome was seven modules with a clean and attractive UI and elegant UX, which
          educated the sales team while communicating the vital message of the disease impact. In
          fact, our proposed approach was so popular we were commissioned to create similar
          programmes for the Rare Diseases and Multiple Sclerosis sales teams.
        </p>
      </TextBlock>
      <IPadPosition>
        <img src={tabletFlat} alt="Dermatitis ipad" />
      </IPadPosition>
    </Content>
  </StyledScreen>
);

export default connect()(FinalProjectScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/screens/FinalProject.jsx